import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer id="contact" className="bg-[#0A0A0A] text-white">
      <div className="px-6 md:px-12 pt-16 pb-8">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="https://public.readdy.ai/ai/img_res/3ccf82e0-7ef8-49c6-b264-45fc943b505b.png"
              alt="SWIFTMARKET LLC"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-white/50 font-inter text-sm leading-relaxed max-w-sm">
              Premium outdoor gear engineered for extreme conditions. From Phoenix desert trails to alpine summits, SWIFTMARKET equips adventurers to conquer the wilderness.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {[
                { icon: 'ri-instagram-line', label: 'Instagram' },
                { icon: 'ri-facebook-line', label: 'Facebook' },
                { icon: 'ri-youtube-line', label: 'YouTube' },
                { icon: 'ri-twitter-x-line', label: 'Twitter' },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#"
                  rel="nofollow"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/50 hover:border-[#C4FF61] hover:text-[#C4FF61] transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-outfit font-semibold text-white text-sm uppercase tracking-widest mb-5">
              <a href="#quick-links" className="hover:text-[#C4FF61] transition-colors">Quick Links</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Shop All Gear', href: '/products' },
                { label: 'New Arrivals', href: '/products' },
                { label: 'Sale Items', href: '/products' },
                { label: 'Gift Cards', href: '#' },
                { label: 'About Us', href: '/about' },
              ].map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.href}
                    className="text-white/50 hover:text-[#C4FF61] font-inter text-sm transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div id="about">
            <h4 className="font-outfit font-semibold text-white text-sm uppercase tracking-widest mb-5">
              <a href="#about" className="hover:text-[#C4FF61] transition-colors">Contact</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-[#C4FF61] text-sm"></i>
                </div>
                <span className="text-white/50 font-inter text-sm leading-relaxed">
                  2825 W Berridge Ln<br />Phoenix, AZ 85017
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-[#C4FF61] text-sm"></i>
                </div>
                <a href="tel:+16025550184" className="text-white/50 hover:text-white font-inter text-sm transition-colors">
                  (602) 555-0184
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-[#C4FF61] text-sm"></i>
                </div>
                <a href="mailto:hello@swiftmarket.com" className="text-white/50 hover:text-white font-inter text-sm transition-colors">
                  hello@swiftmarket.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 font-inter text-xs">
            &copy; 2026 SWIFTMARKET LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            {['Privacy Policy', 'Terms of Service', 'Shipping Info'].map((t) => (
              <a
                key={t}
                href="#"
                rel="nofollow"
                className="text-white/30 hover:text-white/60 font-inter text-xs transition-colors whitespace-nowrap"
              >
                {t}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
